module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Roeschenz-2f92b3adf085298d907d1d5d6ad4b175.png";